module.exports = __webpack_public_path__ + "static/media/search.3e0c2821.svg";